module.exports = __webpack_public_path__ + "img/左侧背景.4024cfbb.png";